import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CreateNew from "../../Components/Button/CreateNew";
import CurrentDraftsTable from "../../Components/Tables/CurrentDraftsTable";
import CurrentLatestTable from "../../Components/Tables/CurrentLatestTable";
import CurrentApprovalsTable from "../../Components/Tables/CurrentApprovalsTable";
import AuthModal from '../../Components/Modal/AuthenticateModal';
import { toast } from 'sonner';

interface Item {
  id: number;
  category: string;
  sub_category: string;
  title: string;
  author: string;
  status: string;
  // Add more properties as per your item structure
}

export default function Video() {
  const [items, setItems] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const isMounted = useRef(true);
  const [itemToDelete, setItemToDelete] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openAuthModal = () => {
    setIsModalOpen(true); 
  };
  
  const closeAuthModal = () => {
    setIsModalOpen(false); 
  };

  useEffect(() => {
    isMounted.current = true;

    const fetchData = async () => {
      try {
        const response = await axios.get("https://cdn.pulp.ph/api/v1/pulpliveworld/video",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );

        if (isMounted.current) {
          setItems(response.data.videos.data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleEditShortstory = (id: number) => {
    navigate("/update/video", { state: { id } }); // Navigate to the VideoEditor without ID in the URL but pass the id through state
  };

  const handleViewShortstory = (id: number) => {
    window.open(`https://pulpmagazine.com/article/video/${id}`, "_blank");
  };

  const handleDelete = (id: number) => {
    setItemToDelete(id);
    openAuthModal();
  };

  const confirmDelete = async () => {
    if (itemToDelete === null) return;

      toast.success(<p className="text-[16px]">Content was deleted successfully!</p>, {
        duration: 1500,
      });

    try {
      const authToken = localStorage.getItem("authToken");
      await axios.delete(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/video/${itemToDelete}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      toast.success(<p className="text-[16px]">Content was deleted successfully!</p>, {
        duration: 1500,
      });
      closeAuthModal();
      setItemToDelete(null);
      setTimeout(() => {
        window.location.reload(); 
      }, 1600);
    } catch (error) {
      console.error("Unable to delete. Please try again.", error);

      toast.error(<p className="text-[16px]">Unable to delete. Please try again.</p>, {
        duration: 1500,
      });
    }
  };

  // const handleDelete = async (id: number) => {
  //   try {
  //     const authToken = localStorage.getItem("authToken");
  //     if (!authToken) {
  //       // Handle the case where authToken is not available
  //       alert("Authentication token not found!");
  //       return;
  //     }

  //     const confirmDelete = window.confirm(
  //       "Are you sure you want to delete this content?"
  //     );

  //     if (!confirmDelete) {
  //       return; // If user cancels, do nothing
  //     }

  //     await axios.delete(
  //       `https://cdn.pulp.ph/api/v1/pulpliveworld/video/${id}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  //         },
  //       }
  //     );
  //     alert("Content Deleted Successfully !!"); // Handle success (e.g., show a success message or redirect)
  //     window.location.reload();
  //   } catch (error) {
  //     console.error("There was an error submitting the form!", error);
  //     // Handle error (e.g., show an error message)
  //   }
  // };

  const handleApprove = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        return;
      }

      const confirmApprove = window.confirm(
        "Are you sure you want to approve this content?"
      );
      if (!confirmApprove) {
        return; // If user cancels, do nothing
      }

      await axios.post(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/video/${id}`,
        {
          status: "Approved", // Add the status Approved in the request body
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      alert("Content Approved Successfully !!"); // Handle success (e.g., show a success message or redirect)
      window.location.reload();
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      // Handle error (e.g., show an error message)
    }
  };

  const handleDecline = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        return;
      }

      const confirmApprove = window.confirm(
        "Are you sure you want to Decline this content?"
      );
      if (!confirmApprove) {
        return; // If user cancels, do nothing
      }

      await axios.post(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/video/${id}`,
        {
          status: "Declined", // Add the status Approved in the request body
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      alert("Content Declined !!"); // Handle success (e.g., show a success message or redirect)
      window.location.reload();
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      // Handle error (e.g., show an error message)
    }
  };

  return (
    <>
      <AuthModal
        isOpen={isModalOpen}
        onClose={closeAuthModal}
        title="Action Verification"
        content={<div className='text-base mb-3'>Are you sure you want to delete this content?</div>}
        footer={
          <>
            <button 
              className="m-0 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
              onClick={closeAuthModal}>
              Close
            </button>
            <button 
              className="m-0 px-4 py-2 text-sm font-medium text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400"
              onClick={confirmDelete}>
              Confirm
            </button>
          </>
        }
      />

      <div className="w-full p-5">
        <div className="flex justify-between items-center mb-4">
          <h2 className="GraphikSemibold text-[20px] text-[#1f2328] font-semibold">List of Video Post</h2>
          <CreateNew />
        </div>

        <div className="flex flex-col mt-5">
          <h3 className="GraphikSemibold text-[18px] text-[#1f2328] font-semibold">Pending Video Post</h3>
          <CurrentDraftsTable items={items} loading={loading} onView={handleViewShortstory} onEdit={handleEditShortstory} onDelete={handleDelete} />
        </div>

        <div className="flex flex-col mt-5">
          <h3 className="GraphikSemibold text-[18px] text-[#1f2328] font-semibold">For Approval</h3>
          <CurrentApprovalsTable items={items} loading={loading} onView={handleViewShortstory} onApprove={handleApprove} onDecline={handleDecline} />
        </div>

        <div className="flex flex-col mt-5">
          <h3 className="GraphikSemibold text-[18px] text-[#1f2328] font-semibold">All Published Videos</h3>
          <CurrentLatestTable items={items} loading={loading} onView={handleViewShortstory} onEdit={handleEditShortstory} onDelete={handleDelete} />
        </div>
      </div>
    </>
  );
}
